import React, { useState } from "react";
import { Form, Card } from "react-bootstrap";
import { Button } from "@mantine/core";
import { Link } from "react-router-dom";


export default function Login(props) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const { handleLogin, error } = props;

  return (
    <>
      <div
        id="wrapper"
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Card
          style={{
            width: "18rem",
            height: "20rem",
          }}
        >
          <Card.Body>
            <h2 className="text-center mb-4">Log In</h2>
            <Form onSubmit={(e) => handleLogin(e, email, password)}>
              <Form.Group id="email">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="email"
                  name="email"
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </Form.Group>
              <Form.Group id="password">
                <Form.Label>Password</Form.Label>
                <Form.Control
                  type="password"
                  name="password"
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </Form.Group>
              <Button
                variant="gradient"
                gradient={{ from: "blue", to: "green", deg: 35 }}
                className="w-100"
                type="submit"
                style={{ marginTop: "1rem" }}
              >
                Log In
              </Button>
            </Form>
            {error && <p style={{ color: "red" }}>{error}</p>}
          </Card.Body>
        </Card>
        <div className="w-100 text-center mt-4" style={{ color: "white" }}>
          Need an account? <Link to="/signup">Sign Up</Link>
        </div>
      </div>
    </>
  );
}
